<template>
    <div class="class-new-root" :style="{ height: tableHeight + 'px' }">
        <div class="content-wrapper">
            <!-- ===== Banner 顶部区域 ===== -->
            <!-- Banner 骨架屏 -->
            <div v-if="bannerLoading" class="banner-card banner-skeleton">
                <div class="banner-skeleton-top">
                    <div class="skeleton-btn"></div>
                    <div class="skeleton-breadcrumb"></div>
                    <div class="skeleton-user"></div>
                </div>
                <div class="banner-skeleton-title"></div>
            </div>
            <!-- Banner 实际内容 -->
            <div v-else class="banner-card">
                <div class="banner-overlay"></div>
                <div class="banner-content">
                    <div class="banner-top">
                        <div class="banner-left">
                            <div class="unit-selector-btn" @click="goBack">
                                <i class="el-icon-s-unfold"></i>
                                <span class="btn-label">选择单元</span>
                            </div>
                            <el-breadcrumb separator-class="el-icon-arrow-right" class="nav-breadcrumb">
                                <el-breadcrumb-item>{{ user.schoolName }}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{ productName }}</el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                        <div class="banner-right">
                            <!-- 主题切换按钮 -->
                            <div class="theme-toggle-btn" @click="toggleTheme"
                                :title="isDarkMode ? '切换到浅色模式' : '切换到深色模式'">
                                <i :class="isDarkMode ? 'el-icon-sunny' : 'el-icon-moon'"></i>
                            </div>
                            <!-- 清除学习进度按钮 -->
                            <div class="theme-toggle-btn" @click="clearAllProgress" title="清除学习进度">
                                <i class="el-icon-refresh"></i>
                            </div>
                            <el-dropdown trigger="click" @command="openHandleClickMore">
                                <div class="user-capsule">
                                    <span class="user-avatar">
                                        <i class="el-icon-user"></i>
                                    </span>
                                    <span class="user-account">{{ maskedAccount }}</span>
                                    <i class="el-icon-arrow-down capsule-arrow"></i>
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item icon="el-icon-unlock" command="view" disabled>有效期：{{
                                        user.expirationDate }}</el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-key" command="bindCode">注册码绑定</el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-switch-button" divided
                                        command="logout">退出登录</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                    <div class="banner-title">
                        <transition name="title-fade" mode="out-in">
                            <span class="banner-title-text" :key="unitTitle">{{ unitTitle }}</span>
                        </transition>
                    </div>
                </div>
            </div>
            <!-- ===== Tabs 主内容区域 ===== -->
            <div class="main-card" :style="{ height: mainCardHeight + 'px' }">
                <!-- 内容骨架屏 -->
                <template v-if="contentLoading">
                    <div class="content-skeleton">
                        <div class="skeleton-tabs">
                            <div class="skeleton-tab-item" v-for="i in 8" :key="i"></div>
                        </div>
                        <div class="skeleton-grid">
                            <div class="skeleton-card" v-for="i in 6" :key="i">
                                <div class="skeleton-card-img"></div>
                                <div class="skeleton-card-text"></div>
                            </div>
                        </div>
                    </div>
                </template>
                <!-- 实际内容 -->
                <template v-else>
                    <el-tabs v-model="activeName" :tab-position="tabPosition" :style="{ height: mainCardHeight + 'px' }"
                        @tab-click="tabClick">
                        <el-tab-pane v-for="(item, index) in panelList" :key="index" class="file-panal"
                            :name="item.name" :disabled="item.count === 0">
                            <template slot="label">
                                <i :class="item.icon"></i>
                                <span class="tab-label-text">{{ item.label }}</span>
                                <span v-show="item.count > 0" class="tab-progress-badge"
                                    :class="{ 'tab-progress-badge--done': item.viewedCount === item.count && item.count > 0 }">{{
                                        item.viewedCount }}/{{ item.count }}</span>
                            </template>
                            <div v-if="item.count === 0 && item.name === activeName" class="empty-state">
                                <i class="el-icon-folder-opened empty-icon"></i>
                                <p class="empty-text">暂无内容</p>
                            </div>
                            <studyNew v-else v-show="item.name === activeName" :isPoint="item.name === '7'"
                                :productList="productList" :activeName="activeName" :mianHeight="mianHeight"
                                :viewedCodes="viewedCodes" @viewed="markViewed"></studyNew>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </div>
        </div>
        <!-- ===== Drawer 抽屉选择面板 ===== -->
        <el-drawer :direction="direction" :visible.sync="drawer" :with-header="false" :size="drawerSize"
            @opened="scrollToActiveUnit">
            <div class="drawer-container">
                <div class="drawer-header">
                    <span class="drawer-title">选择学习单元</span>
                    <div class="drawer-close" @click="drawer = false"><i class="el-icon-close"></i></div>
                </div>
                <div class="selection-path" v-if="selectionPath">
                    <i class="el-icon-location-outline"></i> {{ selectionPath }}
                </div>
                <div class="drawer-body">
                    <div class="filter-bar">
                        <el-select v-model="selectSeries" @change="schange" size="small" placeholder="系列">
                            <el-option v-for="(item, index) in seriesList" :key="index" :label="item.seriesName"
                                :value="item.label"></el-option>
                        </el-select>
                        <el-select v-model="level" @change="lchange" size="small" placeholder="级别">
                            <el-option v-for="(item, index) in filteredMidles" :key="index" :label="item.text"
                                :value="index"></el-option>
                        </el-select>
                        <el-select v-model="selectIndex" @change="bookChange" size="small" placeholder="册">
                            <el-option v-for="(item, index) in filteredLevels" :key="index" :label="item.text"
                                :value="index"></el-option>
                        </el-select>
                    </div>
                    <div class="unit-grid">
                        <div v-for="(item, index) in unitList" :key="index" class="unit-card"
                            :class="{ 'unit-card--active': item.unitNo === (selectUnit && selectUnit.unitNo) }"
                            @click="unitSelectImgHandle(item)">
                            <el-image class="unit-thumb" :title="item.unitName" :src="item.unitThumbnail">
                                <div slot="error" class="image-slot">
                                    <img src="~@/assets/images/error.png" class="unit-thumb-error" />
                                </div>
                            </el-image>
                            <div class="unit-name">{{ item.unitName || ('第' + item.unitNo + '单元') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
        <el-dialog title="授权绑定" id="div-dialog" :visible.sync="bindDialogVisible" width="40%"
            :before-close="handleClose" v-loading="bindLoading">
            <el-form ref="bindForm" :model="form" label-width="80px">
                <el-form-item label="授权码">
                    <el-input v-model="form.code" maxlength="19" show-word-limit placeholder="请输入授权码">
                        <i slot="prefix" class="el-icon-key"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="有效期" v-if="showDate">
                    <el-input v-model="form.date" disabled>
                        <i slot="prefix" class="el-icon-date"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="" style="text-align: right;">
                    <el-button v-if="!showDate" type="primary" @click="bindCode">绑定</el-button>
                    <el-button v-else type="primary" @click="bindDialogVisible = false">关闭</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import debounce from 'lodash/debounce'
import studyNew from '@/components/class/StudyNew.vue'
import api from '@/utils/api'
import { toggleTheme, isDarkMode } from '@/utils/themeUtils'

var STORAGE_KEY = 'classNew_lastSelection'
var BANNER_HEIGHT = 154
var CONTENT_OFFSET = 130

export default {
    name: 'classNew',
    components: {
        studyNew
    },
    data () {
        return {
            timer: null,
            loading: false, // 保留用于兼容，但不再用于全屏 loading
            bannerLoading: true, // Banner 区域 loading
            contentLoading: true, // Tab + 内容区域 loading
            unitsLoading: false, // Drawer 单元列表 loading
            level: 0,
            selectSeries: 2,
            selectProductLevel: 0,
            selectProductUnit: 1,
            selectUnit: null,
            selectPart: null,
            unitTitle: '',
            direction: 'ltr',
            drawer: false,
            activeName: '1',
            seriesList: [],
            unitList: [],
            allProducts: [],
            productList: [],
            tableHeight: 0,
            mianHeight: 0,
            windowWidth: window.innerWidth,
            user: {},
            bindDialogVisible: false,
            form: { code: '', date: '' },
            showDate: false,
            bindLoading: false,
            products: {
                midles: [
                    { series: 0, text: '上' },
                    { series: 1, text: '上级' },
                    { series: 2, text: '上级' },
                    { series: 0, text: '下' },
                    { series: 1, text: '下级' },
                    { series: 2, text: '下级' }
                ],
                levels: [
                    { series: 0, midle: 0, text: '第一册', index: 0 }, { series: 0, midle: 0, text: '第二册', index: 1 }, { series: 0, midle: 0, text: '第三册', index: 2 }, { series: 0, midle: 0, text: '第四册', index: 3 },
                    { series: 0, midle: 1, text: '第五册', index: 0 }, { series: 0, midle: 1, text: '第六册', index: 1 }, { series: 0, midle: 1, text: '第七册', index: 2 }, { series: 0, midle: 1, text: '第八册', index: 3 },
                    { series: 1, midle: 0, text: '预备级', index: 0 }, { series: 1, midle: 0, text: '第一级', index: 1 }, { series: 1, midle: 0, text: '第二级', index: 2 }, { series: 1, midle: 0, text: '第三级', index: 3 },
                    { series: 1, midle: 1, text: '预备级', index: 0 }, { series: 1, midle: 1, text: '第一级', index: 1 }, { series: 1, midle: 1, text: '第二级', index: 2 }, { series: 1, midle: 1, text: '第三级', index: 3 },
                    { series: 2, midle: 0, text: '预备级', index: 0 }, { series: 2, midle: 0, text: '第一级', index: 1 }, { series: 2, midle: 0, text: '第二级', index: 2 }, { series: 2, midle: 0, text: '第三级', index: 3 },
                    { series: 2, midle: 1, text: '预备级', index: 0 }, { series: 2, midle: 1, text: '第一级', index: 1 }, { series: 2, midle: 1, text: '第二级', index: 2 }, { series: 2, midle: 1, text: '第三级', index: 3 }
                ]
            },
            selectIndex: 0,
            productName: '',
            debouncedResize: null,
            isDarkMode: false,
            viewedCodes: []
        }
    },
    computed: {
        tabPosition () {
            return this.windowWidth < 1024 ? 'top' : 'left'
        },
        drawerSize () {
            if (this.windowWidth >= 1024) return '450px'
            if (this.windowWidth >= 768) return '65%'
            return '85%'
        },
        maskedAccount () {
            var account = this.user.account || ''
            if (account.length >= 4) {
                return account.substring(0, account.length - 4) + account.substring(account.length - 4).replace(/\d/g, '*')
            }
            return account.replace(/\d/g, '*')
        },
        filteredMidles () {
            return this.products.midles.filter(w => w.series === this.selectSeries)
        },
        filteredLevels () {
            return this.products.levels.filter(w => w.series === this.selectSeries && w.midle === this.level)
        },
        mainCardHeight () {
            if (this.windowWidth <= 768) return this.tableHeight - 84
            if (this.windowWidth <= 1024) return this.tableHeight - 97
            return this.tableHeight - BANNER_HEIGHT
        },
        groupedProducts () {
            var groups = {}
            this.allProducts.forEach(item => {
                var key = item.courseType.toString()
                if (!groups[key]) groups[key] = []
                groups[key].push(item)
            })
            return groups
        },
        courseTypeCounts () {
            var counts = {}
            Object.keys(this.groupedProducts).forEach(key => {
                counts[key] = this.groupedProducts[key].length
            })
            return counts
        },
        viewedSet () {
            return new Set(this.viewedCodes)
        },
        courseTypeViewedCounts () {
            var counts = {}
            var vs = this.viewedSet
            this.allProducts.forEach(item => {
                var key = item.courseType.toString()
                if (vs.has(item.productCode)) {
                    counts[key] = (counts[key] || 0) + 1
                }
            })
            return counts
        },
        panelList () {
            var counts = this.courseTypeCounts
            var viewed = this.courseTypeViewedCounts
            return [
                { name: '1', icon: 'el-icon-s-platform', label: '课件', count: counts['1'] || 0, viewedCount: viewed['1'] || 0 },
                { name: '2', icon: 'el-icon-video-camera', label: '视频', count: counts['2'] || 0, viewedCount: viewed['2'] || 0 },
                { name: '3', icon: 'el-icon-picture-outline', label: '图片', count: counts['3'] || 0, viewedCount: viewed['3'] || 0 },
                { name: '4', icon: 'el-icon-microphone', label: 'Read Aloud', count: counts['4'] || 0, viewedCount: viewed['4'] || 0 },
                { name: '5', icon: 'el-icon-headset', label: '听力部分', count: counts['5'] || 0, viewedCount: viewed['5'] || 0 },
                { name: '6', icon: 'el-icon-s-promotion', label: '扩展资源', count: counts['6'] || 0, viewedCount: viewed['6'] || 0 },
                { name: '7', icon: 'el-icon-thumb', label: '指读训练', count: counts['7'] || 0, viewedCount: viewed['7'] || 0 },
                { name: '8', icon: 'el-icon-notebook-2', label: 'Workbook听力', count: counts['8'] || 0, viewedCount: viewed['8'] || 0 }
            ]
        },
        selectionPath () {
            var seriesName = ''
            for (var i = 0; i < this.seriesList.length; i++) {
                if (this.seriesList[i].label === this.selectSeries) {
                    seriesName = this.seriesList[i].seriesName
                    break
                }
            }
            if (!seriesName) return ''
            var midText = this.filteredMidles[this.level] ? this.filteredMidles[this.level].text : ''
            var levelItem = this.products.levels.find(w => w.series === this.selectSeries && w.midle === this.level && w.index === this.selectIndex)
            var levelText = levelItem ? levelItem.text : ''
            return seriesName + ' > ' + midText + ' > ' + levelText + ' > 第' + this.selectProductUnit + '单元'
        }
    },
    created () {
        this.restoreSelection()
        this.getProcutName()
        this.tableHeight = window.innerHeight
        this.mianHeight = this.tableHeight - CONTENT_OFFSET
        this.updateThemeState()
        // getSeries 是轻量请求，首屏加载确保下拉框显示正确
        this.getSeries()
        // getUnits 延迟到打开 Drawer 时加载
        this.query()
        this.getUser()
    },
    mounted () {
        this.debouncedResize = debounce(this.handleResize, 200)
        window.addEventListener('resize', this.debouncedResize)
        this.startHeartbeat()
        document.addEventListener('visibilitychange', this.handleVisibilityChange)
        document.addEventListener('fullscreenchange', this.onFullscreenChange)
        document.addEventListener('webkitfullscreenchange', this.onFullscreenChange)
        // 监听主题变化
        this.$nextTick(() => {
            const observer = new MutationObserver(() => {
                this.updateThemeState()
            })
            observer.observe(document.documentElement, {
                attributes: true,
                attributeFilter: ['data-theme']
            })
        })
    },
    beforeDestroy () {
        clearInterval(this.timer)
        if (this.debouncedResize) {
            window.removeEventListener('resize', this.debouncedResize)
        }
        document.removeEventListener('visibilitychange', this.handleVisibilityChange)
        document.removeEventListener('fullscreenchange', this.onFullscreenChange)
        document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange)
    },
    methods: {
        toggleTheme () {
            toggleTheme()
            this.isDarkMode = isDarkMode()
        },
        updateThemeState () {
            this.isDarkMode = isDarkMode()
        },
        handleResize () {
            this.tableHeight = window.innerHeight
            this.mianHeight = this.tableHeight - CONTENT_OFFSET
            this.windowWidth = window.innerWidth
        },
        onFullscreenChange () {
            var fsEl = document.fullscreenElement || document.webkitFullscreenElement
            if (!this.$equipment()) return
            if (fsEl && fsEl.tagName === 'VIDEO') {
                try {
                    screen.orientation.lock('landscape').catch(function () { })
                } catch (e) {
                    // Screen Orientation API not supported
                }
            } else {
                try {
                    screen.orientation.unlock()
                } catch (e) {
                    // ignore
                }
            }
        },
        startHeartbeat () {
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                this.auth()
            }, 1000 * 30)
        },
        handleVisibilityChange () {
            if (document.hidden) {
                clearInterval(this.timer)
            } else {
                this.auth()
                this.startHeartbeat()
            }
        },
        saveSelection () {
            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify({
                    selectSeries: this.selectSeries,
                    level: this.level,
                    selectIndex: this.selectIndex,
                    selectProductLevel: this.selectProductLevel,
                    selectProductUnit: this.selectProductUnit
                }))
            } catch (e) {
                // localStorage not available
            }
        },
        restoreSelection () {
            try {
                var saved = localStorage.getItem(STORAGE_KEY)
                if (saved) {
                    var data = JSON.parse(saved)
                    this.selectSeries = data.selectSeries !== undefined ? data.selectSeries : this.selectSeries
                    this.level = data.level !== undefined ? data.level : this.level
                    this.selectIndex = data.selectIndex !== undefined ? data.selectIndex : this.selectIndex
                    this.selectProductLevel = data.selectProductLevel !== undefined ? data.selectProductLevel : this.selectProductLevel
                    this.selectProductUnit = data.selectProductUnit !== undefined ? data.selectProductUnit : this.selectProductUnit
                }
            } catch (e) {
                // localStorage not available or parse error
            }
        },
        handleApiError () {
            this.$message({ message: '网络异常，请稍后重试', type: 'error' })
        },
        auth () {
            this.$axios.post(api.authCheck)
                .then(res => {
                    if (res.data.result !== 1) {
                        var content = res.data.result === 0 ? '登录身份失效，请重新登录' : '登录人数过多'
                        this.$alert(content, '登录异常', {
                            confirmButtonText: '确定',
                            callback: () => {
                                window.location.href = '/assets/index.html#/login'
                            }
                        })
                    }
                })
                .catch(() => { })
        },
        getUser () {
            this.$axios.post(api.getUserInfo)
                .then(res => {
                    this.user = res.data.result
                    this.form.date = res.data.result.expirationDate
                    this.bannerLoading = false
                })
                .catch(() => {
                    this.bannerLoading = false
                    this.handleApiError()
                })
        },
        getSeries () {
            if (this.seriesList.length > 0) return // 已加载过，跳过
            this.$axios.get(api.getProductSeries)
                .then(res => {
                    this.seriesList = res.data.result
                })
                .catch(this.handleApiError)
        },
        getUnits (showLoading) {
            if (showLoading) {
                this.unitsLoading = true
            }
            this.getProcutName()
            this.$axios.get(api.getProductUnits(this.selectSeries, this.selectProductLevel))
                .then(res => {
                    this.unitList = res.data.result
                    this.selectUnit = this.unitList.find(f => f.unitNo === this.selectProductUnit) || null
                    this.unitsLoading = false
                })
                .catch(() => {
                    this.unitsLoading = false
                    this.handleApiError()
                })
        },
        getProcutName () {
            var midles = this.filteredMidles
            var midText = midles[this.level] ? midles[this.level].text : ''
            var levelItem = this.products.levels.find(w => w.series === this.selectSeries && w.midle === this.level && w.index === this.selectIndex)
            var levelText = levelItem ? levelItem.text : ''
            this.productName = levelText + midText + '第' + this.selectProductUnit + '单元'
        },
        query () {
            this.getProcutName()
            this.$axios.post(api.getProductParts, { PageIndex: 1, Series: this.selectSeries, Level: this.selectProductLevel, ProductUnit: this.selectProductUnit, PageSize: 100 })
                .then(res => {
                    this.allProducts = res.data.result.items.map(item => {
                        item.previewurl = [item.sourceUrl]
                        return item
                    })
                    this.productList = this.groupedProducts[this.activeName] || []
                    this.selectPart = this.productList[0] || null
                    this.loadProgress()
                    this.contentLoading = false
                })
                .catch(() => {
                    this.contentLoading = false
                    this.handleApiError()
                })
            this.getunittitle()
        },
        getunittitle () {
            this.$axios.get(api.getUnitTitle(this.selectSeries, this.selectProductLevel, this.selectProductUnit))
                .then(res => {
                    this.unitTitle = res.data.result.unitTitle
                })
                .catch(this.handleApiError)
        },
        tabClick (tab) {
            this.selectTab = tab.name
            this.activeName = tab.name
            this.productList = this.groupedProducts[this.activeName] || []
        },
        btnclik (index) {
            this.selectIndex = index
            this.selectProductLevel = index * 10 + this.level
            this.getUnits(false)
            this.saveSelection()
        },
        goBack () {
            this.drawer = true
            // 延迟加载单元列表
            if (this.unitList.length === 0) {
                this.getUnits(true)
            }
        },
        scrollToActiveUnit () {
            this.$nextTick(() => {
                var active = this.$el.querySelector('.unit-card--active')
                if (active) {
                    active.scrollIntoView({ behavior: 'smooth', block: 'center' })
                }
            })
        },
        schange () {
            this.level = 0
            this.btnclik(0)
            this.saveSelection()
        },
        lchange () {
            this.btnclik(0)
            this.saveSelection()
        },
        bookChange (index) {
            this.btnclik(index)
        },
        unitSelectImgHandle (item) {
            this.selectProductUnit = item.unitNo
            this.selectUnit = item
            this.getProcutName()
            this.query()
            this.saveSelection()
        },
        openHandleClickMore (command) {
            if (command === 'logout') {
                this.$confirm('确定退出登录吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.post(api.logout)
                        .then(() => {
                            window.location.href = '/'
                        })
                        .catch(this.handleApiError)
                }).catch(() => { })
            }
            if (command === 'bindCode') {
                this.showDate = false
                this.form.code = ''
                this.bindDialogVisible = true
            }
        },
        compareDates (date1, date2) {
            var time1 = new Date(date1).getTime()
            var time2 = new Date(date2).getTime()
            return Math.sign(time1 - time2)
        },
        handleClose (done) {
            var now = new Date().toLocaleDateString()
            if (this.compareDates(this.user.expirationDate, now) === -1) {
                this.$message({
                    message: '账号已到期，请绑定新的授权码',
                    type: 'warning'
                })
            } else {
                this.bindDialogVisible = false
            }
        },
        bindCode () {
            if (this.form.code === '') {
                this.$message({ message: '授权码不能为空', type: 'warning' })
                return
            }
            if (this.form.code.length !== 19) {
                this.$message({ message: '授权码必须为19位', type: 'warning' })
                return
            }
            if (this.form.code.indexOf('-') === -1) {
                this.$message({ message: '授权码格式错误', type: 'warning' })
                return
            }
            this.bindLoading = true
            this.$axios.post(api.bindCode, { code: this.form.code })
                .then(res => {
                    this.bindLoading = false
                    if (res.data.result.status) {
                        this.getUser()
                        this.form.date = res.data.result.expiredDate
                        this.showDate = true
                        this.$message({ message: res.data.result.message, type: 'info' })
                    } else {
                        this.$message({ message: res.data.result.message, type: 'error' })
                    }
                })
                .catch(() => {
                    this.bindLoading = false
                    this.handleApiError()
                })
        },
        loadProgress () {
            this.$axios.get(api.queryProgress(this.selectSeries, this.selectProductLevel, this.selectProductUnit))
                .then(res => {
                    this.viewedCodes = res.data.result.viewedProductCodes || []
                })
                .catch(() => { })
        },
        markViewed (productCode, courseType) {
            if (this.viewedSet.has(productCode)) return
            this.viewedCodes = this.viewedCodes.concat([productCode])
            this.$axios.post(api.reportProgress, {
                ProductCode: productCode,
                CourseType: courseType,
                Series: this.selectSeries,
                Level: this.selectProductLevel,
                UnitNo: this.selectProductUnit
            }).catch(() => { })
        },
        clearAllProgress () {
            this.$confirm('确定清除所有学习进度记录吗？此操作不可恢复。', '清除学习进度', {
                confirmButtonText: '确定清除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post(api.clearProgress)
                    .then(() => {
                        this.viewedCodes = []
                        this.$message({ message: '学习进度已清除', type: 'success' })
                    })
                    .catch(this.handleApiError)
            }).catch(() => { })
        }
    }
}
</script>
<style scoped lang="scss">
// ==================== 根容器 ====================
.class-new-root {
    background: linear-gradient(135deg, var(--page-gradient-start) 0%, var(--page-gradient-mid) 50%, var(--page-gradient-end) 100%);
    touch-action: manipulation;
    overflow: hidden;
}

.content-wrapper {
    margin: 0 auto;
    width: 78%;
    max-width: 1400px;
    padding-top: 18px;
    padding-bottom: 18px;
}

// ==================== 骨架屏样式 ====================
@keyframes skeleton-pulse {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}

.skeleton-shimmer {
    background: linear-gradient(90deg,
            var(--skeleton-bg, #f0f2f5) 25%,
            var(--skeleton-highlight, #e8ebed) 50%,
            var(--skeleton-bg, #f0f2f5) 75%);
    background-size: 200% 100%;
    animation: skeleton-pulse 1.5s ease-in-out infinite;
}

// Banner 骨架屏
.banner-skeleton {
    background: var(--skeleton-bg, #f0f2f5);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 14px 20px;

    .banner-skeleton-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 28px;
    }

    .skeleton-btn {
        @extend .skeleton-shimmer;
        width: 100px;
        height: 28px;
        border-radius: 6px;
    }

    .skeleton-breadcrumb {
        @extend .skeleton-shimmer;
        width: 180px;
        height: 16px;
        border-radius: 4px;
        margin-left: 12px;
    }

    .skeleton-user {
        @extend .skeleton-shimmer;
        width: 120px;
        height: 28px;
        border-radius: 14px;
    }

    .banner-skeleton-title {
        @extend .skeleton-shimmer;
        width: 200px;
        height: 32px;
        border-radius: 6px;
        margin: 0 auto;
    }
}

// 内容区骨架屏
.content-skeleton {
    display: flex;
    height: 100%;
    padding: 8px;

    .skeleton-tabs {
        width: 180px;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding: 8px;
        background: var(--tab-header-gradient-start, #fafbfc);
        border-radius: 12px 0 0 12px;

        .skeleton-tab-item {
            @extend .skeleton-shimmer;
            height: 40px;
            border-radius: 6px;
        }
    }

    .skeleton-grid {
        flex: 1;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
        gap: 16px;
        padding: 16px;
        align-content: start;

        .skeleton-card {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .skeleton-card-img {
                @extend .skeleton-shimmer;
                aspect-ratio: 4 / 3;
                border-radius: 8px;
            }

            .skeleton-card-text {
                @extend .skeleton-shimmer;
                height: 14px;
                border-radius: 4px;
                width: 70%;
            }
        }
    }
}

// 移动端骨架屏适配
@media (max-width: 1024px) {
    .content-skeleton {
        flex-direction: column;

        .skeleton-tabs {
            width: 100%;
            flex-direction: row;
            flex-wrap: nowrap;
            overflow: hidden;
            border-radius: 12px 12px 0 0;
            padding: 8px 12px;
            gap: 8px;

            .skeleton-tab-item {
                width: 80px;
                flex-shrink: 0;
                height: 32px;
            }
        }

        .skeleton-grid {
            grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
            gap: 12px;
            padding: 12px;
        }
    }
}

@media (max-width: 768px) {
    .banner-skeleton {
        .skeleton-breadcrumb {
            display: none;
        }

        .skeleton-btn {
            width: 70px;
        }

        .skeleton-user {
            width: 90px;
        }
    }

    .content-skeleton {
        padding: 0;

        .skeleton-tabs {
            padding: 6px 10px;
            gap: 6px;

            .skeleton-tab-item {
                width: 60px;
                height: 28px;
            }
        }

        .skeleton-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
            padding: 8px;
        }
    }
}

// ==================== Banner 顶部卡片 ====================
.banner-card {
    position: relative;
    background-image: url('~@/assets/images/banner-edu.jpg');
    background-size: cover;
    background-position: center;
    height: 118px;
    border-radius: 12px 12px 0 0;
    margin-bottom: 0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.10);
    overflow: hidden;
}

.banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg,
            var(--banner-overlay-start) 0%,
            var(--banner-overlay-end) 100%);
    z-index: 0;
}

.banner-content {
    position: relative;
    z-index: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.banner-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 20px;
}

.banner-left {
    display: flex;
    align-items: center;
    gap: 12px;
    overflow: hidden;
    flex: 1;
    min-width: 0;
}

.unit-selector-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s ease;
    padding: 4px 10px;
    border-radius: 6px;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);

    &:hover {
        background: rgba(255, 255, 255, 0.15);
    }

    .btn-label {
        font-size: 14px;
        font-weight: 600;
    }
}

.nav-breadcrumb {
    line-height: 1;
}

::v-deep .el-breadcrumb__separator,
::v-deep .el-breadcrumb__inner {
    font-size: 15px;
    color: #fff;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__separator {
    color: #fff;
}

::v-deep .el-breadcrumb__inner a i {
    color: #fff;
}

::v-deep .el-icon-arrow-right {
    color: #909399;
    font-weight: 700;
    font-size: 13px;
}

.banner-right {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    padding-left: 16px;
    gap: 8px;
}

// 主题切换按钮
.theme-toggle-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    cursor: pointer;
    transition: all 0.25s ease;
    color: #fff;
    font-size: 18px;

    &:hover {
        background: rgba(255, 255, 255, 0.3);
        border-color: rgba(255, 255, 255, 0.4);
        transform: scale(1.05);
    }

    i {
        line-height: 1;
    }
}

.user-capsule {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 5px 14px 5px 5px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.18);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.25);
    cursor: pointer;
    transition: all 0.25s ease;
    color: #fff;

    &:hover {
        background: rgba(255, 255, 255, 0.3);
        border-color: rgba(255, 255, 255, 0.4);
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    }
}

.user-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.35);
    font-size: 14px;
    color: #fff;
    flex-shrink: 0;
}

.user-account {
    font-size: 13px;
    font-weight: 500;
    color: #fff;
    letter-spacing: 0.3px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

.capsule-arrow {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    transition: transform 0.2s;
}

::v-deep .el-dropdown {
    cursor: pointer;
}

.banner-title {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.banner-title-text {
    font-size: 2em;
    font-weight: 800;
    color: #fff;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    letter-spacing: 1.5px;
}

// ==================== 主内容卡片 (Tabs) ====================
.main-card {
    border-radius: 0 0 12px 12px;
    background: var(--bg-white);
    box-shadow: var(--shadow-base);
    border: 1px solid var(--border-lighter);
    border-top: none;
    overflow: hidden;
}

// 覆盖 Element UI 的 float 布局，改用 flexbox 实现正确的高度传递链
::v-deep .el-tabs {
    display: flex !important;
}

::v-deep .el-tabs--left {
    flex-direction: row !important;
}

::v-deep .el-tabs--left>.el-tabs__header {
    float: none !important;
    flex-shrink: 0;
}

::v-deep .el-tabs--top {
    flex-direction: column !important;
}

::v-deep .el-tabs--top>.el-tabs__header {
    flex-shrink: 0;
}

::v-deep .el-tabs__content {
    padding: 8px 8px;
    flex: 1 1 0% !important;
    min-height: 0 !important;
    overflow: hidden !important;
    box-sizing: border-box;
    display: flex !important;
    flex-direction: column !important;
}

::v-deep .el-tab-pane {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

::v-deep .el-tabs__header {
    background: linear-gradient(180deg, var(--tab-header-gradient-start) 0%, var(--tab-header-gradient-end) 100%);
    margin-right: 0;
}

::v-deep .el-tabs--left .el-tabs__header {
    border-radius: 12px 0 0 12px;
    width: 180px;
    min-width: 180px;
}

::v-deep .el-tabs--top .el-tabs__header {
    border-radius: 12px 12px 0 0;
}

::v-deep .el-tabs__nav {
    transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}

::v-deep .el-tabs__item {
    font-size: 15px;
    min-width: 168px;
    height: 48px;
    line-height: 48px;
    transition: all 0.25s ease;
    padding-left: 20px !important;
    color: var(--text-regular);
}

::v-deep .el-tabs--left .el-tabs__item.is-active {
    border-left: 3px solid var(--primary-color, #409EFF);
    background: var(--tab-active-bg);
    font-weight: 600;
    color: var(--text-primary);
}

::v-deep .el-tabs--left .el-tabs__item:hover:not(.is-active) {
    background: var(--tab-hover-bg);
    color: var(--primary-color, #409EFF);
}

::v-deep .el-tabs--top .el-tabs__item.is-active {
    border-bottom: 2px solid var(--primary-color, #409EFF);
    font-weight: 600;
    color: var(--primary-color, #409EFF);
}

::v-deep .el-tabs--top .el-tabs__item:hover:not(.is-active):not(.is-disabled) {
    color: var(--primary-color, #409EFF);
    background: var(--tab-hover-bg);
}

::v-deep .el-tabs__item i {
    padding-right: 6px;
    color: var(--tab-icon-color);
    font-weight: 700;
    font-size: 16px;
    transition: color 0.25s ease;
}

::v-deep .is-active i {
    color: var(--primary-color, #409EFF);
}

::v-deep .el-badge {
    line-height: 18px;
    margin-left: 6px;
}

// ===== Tab 进度徽章 =====
.tab-progress-badge {
    display: inline-block;
    margin-left: 6px;
    font-size: 11px;
    font-weight: 600;
    padding: 1px 6px;
    border-radius: 10px;
    background: var(--tab-hover-bg, #f0f2f5);
    color: var(--text-secondary, #909399);
    line-height: 16px;
    vertical-align: middle;
}

.tab-progress-badge--done {
    background: var(--success-lighter, #f0f9eb);
    color: var(--success-color, #67C23A);
}

::v-deep .el-tabs__item.is-disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

// ===== Tab 左右翻页箭头 =====
::v-deep .el-tabs__nav-prev,
::v-deep .el-tabs__nav-next {
    font-size: 16px;
    color: var(--text-regular);
    width: 32px;
    text-align: center;
    line-height: 48px;
    z-index: 2;
}

::v-deep .el-tabs__nav-prev:hover,
::v-deep .el-tabs__nav-next:hover {
    color: #409EFF;
}

// ===== 空状态 =====
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: var(--text-placeholder);
}

.empty-icon {
    font-size: 48px;
    margin-bottom: 12px;
}

.empty-text {
    font-size: 14px;
    margin: 0;
}

// ===== Banner 标题过渡 =====
.title-fade-enter-active,
.title-fade-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.title-fade-enter {
    opacity: 0;
    transform: translateY(8px);
}

.title-fade-leave-to {
    opacity: 0;
    transform: translateY(-8px);
}

// ==================== Drawer 抽屉面板 ====================
// 修复 el-drawer 内部 body 高度约束，使子容器可滚动
::v-deep .el-drawer__body {
    height: 100%;
    overflow: hidden;
}

.drawer-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}

.drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: linear-gradient(135deg, var(--drawer-header-gradient-start) 0%, var(--drawer-header-gradient-end) 100%);
    border-bottom: 1px solid var(--border-light);
    flex-shrink: 0;
}

.drawer-title {
    font-size: 17px;
    font-weight: 700;
    color: var(--text-primary);
    letter-spacing: 0.5px;
}

.drawer-close {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    color: var(--text-secondary);
    font-size: 18px;
    transition: all 0.2s;

    &:hover {
        background: var(--bg-hover);
        color: var(--text-primary);
    }
}

.selection-path {
    padding: 10px 16px;
    background: linear-gradient(135deg, var(--selection-path-bg-start) 0%, var(--selection-path-bg-end) 100%);
    color: var(--primary-color, #409EFF);
    font-size: 13px;
    font-weight: 500;
    border-radius: 8px;
    margin: 12px 16px 0;
    border: 1px solid var(--selection-path-border);
    flex-shrink: 0;

    i {
        margin-right: 6px;
    }
}

.drawer-body {
    padding: 0 16px 24px;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.drawer-body::-webkit-scrollbar {
    width: 6px;
}

.drawer-body::-webkit-scrollbar-track {
    background: transparent;
}

.drawer-body::-webkit-scrollbar-thumb {
    background: var(--scrollbar-thumb);
    border-radius: 3px;

    &:hover {
        background: var(--scrollbar-thumb-hover);
    }
}

// ===== 筛选栏 =====
.filter-bar {
    display: flex;
    gap: 8px;
    padding: 12px 0;
    flex-shrink: 0;

    .el-select {
        flex: 1;
    }
}

// ===== 单元缩略图网格 =====
.unit-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 12px;
    padding: 8px 4px 24px;
    align-content: flex-start;
}

.unit-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    padding: 8px;
    border-radius: 10px;
    border: 2px solid transparent;
    transition: all 0.25s ease;
    width: calc(50% - 6px);
    box-sizing: border-box;

    &:hover {
        background: var(--unit-card-hover-bg);
        transform: translateY(-2px);
        box-shadow: var(--shadow-light);
    }
}

.unit-card--active {
    border-color: #409EFF;
    background: var(--tab-active-bg);
    box-shadow: 0 4px 16px rgba(64, 158, 255, 0.2);
    transform: translateY(-2px);
}

.unit-thumb {
    width: 100%;
    height: auto;
    aspect-ratio: 4 / 3;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.unit-thumb-error {
    width: 100%;
    height: auto;
    aspect-ratio: 4 / 3;
    border-radius: 8px;
    object-fit: cover;
}

.unit-name {
    font-size: 12px;
    color: var(--text-regular);
    margin-top: 6px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    font-weight: 500;
    line-height: 1.4;
}

// ==================== Responsive ====================

@media (max-width: 1440px) {
    .content-wrapper {
        width: 90%;
    }
}

@media (max-width: 1024px) {
    .content-wrapper {
        width: 95%;
        padding-top: 6px;
    }

    .banner-card {
        height: 85px;
        border-radius: 8px 8px 0 0;
    }

    .banner-top {
        height: 40px;
        padding: 0 14px;
    }

    .unit-selector-btn {
        font-size: 18px;
    }

    .banner-title-text {
        font-size: 1.4em;
    }

    ::v-deep .el-tabs__item {
        min-width: auto;
        padding: 0 16px !important;
        font-size: 14px;
        height: 46px;
        line-height: 46px;
    }

    ::v-deep .el-tabs__nav-prev,
    ::v-deep .el-tabs__nav-next {
        line-height: 46px;
    }

    ::v-deep .el-tabs__header {
        border-radius: 0;
    }

    .main-card {
        border-radius: 0 0 8px 8px;
    }

    ::v-deep .el-breadcrumb__separator,
    ::v-deep .el-breadcrumb__inner {
        font-size: 13px;
    }
}

@media (max-width: 768px) {
    .content-wrapper {
        width: 100%;
        padding: 0;
    }

    // ===== 移动端 Banner 精简 =====
    .banner-card {
        height: 80px;
        border-radius: 0;
        margin-bottom: 0;
        box-shadow: none;
    }

    .banner-top {
        height: 32px;
        padding: 0 12px;
    }

    .banner-title {
        padding: 0 12px;
    }

    .banner-title-text {
        font-size: 1.15em;
        letter-spacing: 0.5px;
    }

    .unit-selector-btn {
        font-size: 16px;
        padding: 2px 6px;

        .btn-label {
            display: none;
        }
    }

    .nav-breadcrumb {
        display: none;
    }

    .user-capsule {
        padding: 3px 10px 3px 3px;
        gap: 5px;
    }

    .user-avatar {
        width: 24px;
        height: 24px;
        font-size: 12px;
    }

    .user-account {
        font-size: 12px;
    }

    ::v-deep .el-breadcrumb__separator,
    ::v-deep .el-breadcrumb__inner {
        font-size: 12px;
    }

    // ===== 移动端 Tab 栏重新设计 =====
    .main-card {
        border-radius: 0;
        box-shadow: none;
        border: none;
    }

    ::v-deep .el-tabs__header {
        background: var(--bg-white);
        margin: 0;
        border-bottom: 1px solid var(--border-lighter);
    }

    ::v-deep .el-tabs__nav {
        border: none !important;
    }

    ::v-deep .el-tabs__item {
        min-width: auto;
        font-size: 13px;
        padding: 0 14px !important;
        height: 42px;
        line-height: 42px;
        color: var(--text-secondary);
        border-bottom: none !important;
        position: relative;
        transition: color 0.2s ease;

        i {
            font-size: 15px;
            padding-right: 3px;
        }

        &.is-active {
            color: var(--primary-color, #409EFF);
            font-weight: 600;

            i {
                color: var(--primary-color, #409EFF);
            }
        }

        &.is-active::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 24px;
            height: 3px;
            background: var(--primary-color, #409EFF);
            border-radius: 3px 3px 0 0;
        }

        &.is-disabled {
            color: var(--text-placeholder);
        }
    }

    ::v-deep .el-tabs__active-bar {
        display: none;
    }

    // Badge 样式优化
    ::v-deep .el-tabs__item .el-badge {
        margin-left: 2px;
    }

    ::v-deep .el-badge__content {
        font-size: 10px;
        height: 16px;
        line-height: 16px;
        padding: 0 4px;
        border: none;
    }

    // ===== 箭头按钮：圆形设计 =====
    ::v-deep .el-tabs__nav-prev,
    ::v-deep .el-tabs__nav-next {
        width: 28px;
        height: 28px;
        line-height: 28px;
        font-size: 14px;
        font-weight: 700;
        color: #fff;
        background: var(--primary-color, #409EFF);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 50%;
        transform: translateY(-50%);
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.35);
        z-index: 3;
        transition: background 0.2s ease;

        &:active {
            background: #337ecc;
        }
    }

    ::v-deep .el-tabs__nav-wrap.is-scrollable {
        padding: 0 36px;
    }

    ::v-deep .el-tabs__nav-wrap::after {
        display: none;
    }

    ::v-deep .el-tabs__nav-scroll {
        -webkit-overflow-scrolling: touch;
    }

    ::v-deep .el-tabs__content {
        padding: 6px !important;
    }

    // ===== Drawer & Grid =====
    .unit-card {
        width: calc(50% - 4px);
        padding: 6px;
    }

    .drawer-header {
        padding: 12px 14px;
    }

    .drawer-body {
        padding: 0 12px 20px;
    }

    .unit-grid {
        gap: 8px;
    }
}

@import '@/styles/variables.scss';
</style>



// WEBPACK FOOTER //
// src/components/class/ClassNew.vue